<template>
  <div>
    <b-modal id="modalHotspotService" ref="modalHotspotService" :title="$t('Hotspot service')" hide-footer size="lg" @shown="shown">
      <div v-if="editItem  && (serviceType === 4)">
        <b-tabs pills card vertical>
          <b-tab :title="$t('Main')">
            <b-form-group label-align="right" :label="$t('Parent service')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isTariffs || isTariffPlan">
              <b-form-input type="text" disabled v-model="editItem.service_data.parent_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.service_data.service_name" aria-describedby="inputFeedbackName" :state="editItem.service_data.service_name.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                {{ $t('Enter title') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.service_data.comment"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Supplier to invoice')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="suppliertList" v-model="editItem.service_data.invoice_sup_id"/>
            </b-form-group>
            <b-form-group v-if="isTemplates || isTariffs || isTariffPlan">
              <b-form-checkbox v-model="editItem.service_data.link_by_default" value=1 unchecked-value=0>{{ $t('Attach by default') }}</b-form-checkbox>
              <b-form-checkbox v-model="editItem.service_data.multiple_linking" value=1 unchecked-value=0>{{ $t('Allow multiple linking') }}</b-form-checkbox>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Service parameters')">
            <b-form-group label-align="right" :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" :disabled="editItem.service_data.links_count !== 0" v-model="editItem.periodic_service_data.cost" aria-describedby="inputFeedbackCost" :state="editItem.periodic_service_data.cost !== ''"/>
              <b-form-invalid-feedback id="inputFeedbackCost">
                {{ $t('Enter cost') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charge method')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="chargeMethodList" v-model="editItem.periodic_service_data.charge_method"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="policyList" v-model="editItem.periodic_service_data.policy_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Contract type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="contractList" v-model="editItem.service_data.contract_type"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Limit of simultaneous sessions')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem.periodic_service_data.radius_sessions_limit"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Dinamic IP address allocation')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox v-model="editItem.service_data.is_dynamic" value="1" unchecked-value="0"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Hotspot allowed networks')">
            <b-row>
              <b-col>
                <md-button class="md-raised md-dense" @click="swohAddNetwork">{{ $t('Add') }}</md-button>
              </b-col>
            </b-row>
            <b-table small striped hover :items="editItem.hotspot_service_data.allowed_net" :fields="networkFields">
              <template v-slot:cell(actions)="row">
                <i @click.stop="ClickOnEditNetworkButton(row)" class="primary fa fa-edit fa-lg"/>
                <i @click.stop="deleteNetwork(row)" class="danger fa fa-trash-alt fa-lg"/>
              </template>
            </b-table>
          </b-tab>
          <b-tab :title="$t('Prices per hour')">
            <b-row>
              <b-col>
                <md-button class="md-raised md-dense" @click="swohAddTimeRange">{{ $t('Add') }}</md-button>
              </b-col>
            </b-row>
            <b-table small striped hover :items="editItem.hotspot_service_data.costs" :fields="timeRangeFields">
              <template v-slot:cell(actions)="row">
                <i @click.stop="ClickOnEditTimeRangeButton(row)" class="primary fa fa-edit fa-lg"/>
                <i @click.stop="deleteTimeRange(row)" class="danger fa fa-trash-alt fa-lg"/>
              </template>
            </b-table>
          </b-tab>
          <b-tab :title="$t('Radius parameters')">
            <b-row>
              <b-col>
                <md-button class="md-raised md-dense" @click="swohAddRadiusAttr">{{ $t('Add') }}</md-button>
              </b-col>
            </b-row>
            <b-table small striped hover :items="radiusAttrItems" :fields="radiusAttrFields">
              <template v-slot:cell(actions)="row">
                <i @click.stop="ClickOnEditRadiusAttrButton(row)" class="primary fa fa-edit fa-lg"/>
                <i @click.stop="deleteRadiusAttr(row)" class="danger fa fa-trash-alt fa-lg"/>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>

        <modal-ok-cancel @save="saveHotspotService" @cancel="$refs.modalHotspotService.hide" size="lg"/>
      </div>
    </b-modal>

    <b-modal hide-footer :title="$t('Time range')" ref="modalTimeRange">
      <b-form-group label-align="right" :label="$t('Time range')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-select :options="timeRangeList" v-model="selectTimeRange" :disabled="isEditTimeRange"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Cost per hour')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="newTimeRange.cost"/>
      </b-form-group>

      <modal-ok-cancel @save="saveTimeRange" @cancel="hideModalTimeRange" size="md"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Hotspot allowed networks')" ref="modalNetwork">
      <b-form-group label-align="right" :label="$t('Network')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="newNetwork.network" placeholder="0.0.0.0"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Mask')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="newNetwork.mask" placeholder="255.255.255.255"/>
      </b-form-group>

      <modal-ok-cancel @save="saveNetwork" @cancel="hideAddNetwork" size="md"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Radius parameters')" ref="modalRadiusAttr" size="lg">
      <FormRadiusAttributs
      @hideAddRadiusAttr="hideAddRadiusAttr"
      :isEditRadiusAttr="isEditRadiusAttr"
      :rowRadiusAttr="rowRadiusAttr"
      :radiusAttrItems="radiusAttrItems"/>
    </b-modal>
  </div>
</template>

<script>
import FormRadiusAttributs from '@/pages/tariffication/servicesAndTariffs/formRadiusAttributs'
export default {
  components: {
    FormRadiusAttributs
  },
  props: {
    serviceType: null,
    timeRangeList: null,
    policyList: null,
    suppliertList: null,
    contractList: null,
    isTariffs: null,
    isTemplates: null,
    isEdit: null,
    isTariffPlan: null,
    editItem: null,
    currentRowTariffPlans: null
  },
  data () {
    return {
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png'),
      networkFields: [
        {key: 'network', label: this.$i18n.t('Network'), sortable: true},
        {key: 'mask', label: this.$i18n.t('Mask'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      timeRangeFields: [
        {key: 'timerange_id', label: this.$i18n.t('Time range ID'), sortable: true},
        {key: 'time_range_name', label: this.$i18n.t('Time range name'), sortable: true},
        {key: 'cost', label: this.$i18n.t('Cost per hour'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      radiusAttrItems: [],
      radiusAttrFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      newTimeRange: {
        'cost': 0,
        'time_range_name': '',
        'timerange_id': 0
      },
      emptyTimeRange: {
        'cost': 0,
        'time_range_name': '',
        'timerange_id': 0
      },
      newNetwork: {
        'network': '',
        'mask': '',
        'maskDec': 0
      },
      emptyNetwork: {
        'network': '',
        'mask': '',
        'maskDec': 0
      },
      rowRadiusAttr: null,
      isEditNetwork: false,
      isEditRadiusAttr: false,
      isEditTimeRange: false,
      selectTimeRange: 1,
      chargeMethodList: [
        {text: this.$i18n.t('At the start of the period'), value: 1},
        {text: this.$i18n.t('At the end of the period'), value: 2},
        {text: this.$i18n.t('Flow method'), value: 3}
      ],
      num: 0,
      arrMask: new Map([
        ['255.255.255.255', 32],
        ['255.255.255.254', 31],
        ['255.255.255.252', 30],
        ['255.255.255.248', 29],
        ['255.255.255.240', 28],
        ['255.255.255.224', 27],
        ['255.255.255.192', 26],
        ['255.255.255.128', 25],
        ['255.255.255.0', 24],
        ['255.255.254.0', 23],
        ['255.255.252.0', 22],
        ['255.255.248.0', 21],
        ['255.255.240.0', 20],
        ['255.255.224.0', 19],
        ['255.255.192.0', 18],
        ['255.255.128.0', 17],
        ['255.255.0.0', 16],
        ['255.254.0.0', 15],
        ['255.252.0.0', 14],
        ['255.248.0.0', 13],
        ['255.240.0.0', 12],
        ['255.224.0.0', 11],
        ['255.192.0.0', 10],
        ['255.128.0.0', 9],
        ['255.0.0.0', 8],
        ['254.0.0.0', 7],
        ['252.0.0.0', 6],
        ['248.0.0.0', 5],
        ['240.0.0.0', 4],
        ['224.0.0.0', 3],
        ['192.0.0.0', 2],
        ['128.0.0.0', 1],
        ['0.0.0.0', 0]
      ])
    }
  },
  methods: {
    saveHotspotService () {
      if (!this.editItem.service_data.service_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (!this.editItem.hotspot_service_data.costs.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Prices per hour table is empty'), 'Error')
        return
      }
      if (this.editItem.periodic_service_data.radius_sessions_limit === '') {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Limit of simultaneous sessions field is invalid'), 'Error')
        return
      }

      if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
        if (this.editItem.service_data.parent_id === 0) this.editItem.service_data.parent_id = -1
        this.editItem.service_data.link_by_default = Number(this.editItem.service_data.link_by_default)
        this.editItem.service_data.multiple_linking = 'multiple_linking' in this.editItem.service_data ? this.editItem.service_data.multiple_linking : 0
        this.editItem.service_data.multiple_linking = Number(this.editItem.service_data.multiple_linking)
      }
      if (this.isTariffPlan) {
        this.editItem.service_data.tariff_id = this.currentRowTariffPlans.id
      }
      this.editItem.periodic_service_data.cost = Number(this.editItem.periodic_service_data.cost)
      this.editItem.periodic_service_data.radius_sessions_limit = Number(this.editItem.periodic_service_data.radius_sessions_limit)
      this.editItem.service_data.is_dynamic = Number(this.editItem.service_data.is_dynamic)
      let response = this.isEdit
        ? this.$store.dispatch('Tariffing/UPDATE_HOTSPOT_SERVICE', this.editItem)
        : this.$store.dispatch('Tariffing/CREATE_HOTSPOT_SERVICE', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
          this.$refs.modalHotspotService.hide()
          this.$root.$emit('makeToasts')

          let sid = this.isEdit ? this.editItem.service_data.service_id : response.data.service_id
          let invID = this.editItem.service_data.invoice_sup_id ? this.editItem.service_data.invoice_sup_id : 0
          this.$store.dispatch('Tariffing/UPDATE_SUPPLIER_ID', {service_id: sid, invoice_sup_id: invID})

          this.$store.dispatch('Tariffing/SET_HOTSPOT_NETWORKS', {service_id: sid, allowed_net: this.editItem.hotspot_service_data.allowed_net})

          this.$store.dispatch('Tariffing/UPDATE_CHARGE_POLICY', {service_id: sid, policy_id: this.editItem.periodic_service_data.policy_id})

          if (this.isTemplates || this.isTariffPlan) {
            let ml = this.editItem.service_data.multiple_linking ? this.editItem.service_data.multiple_linking : 0
            this.$store.dispatch('Tariffing/UPDATE_MULTI_LINKING', {service_id: sid, multiple_linking: ml})
          }

          this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', {set_object_id: sid, set_type: 4, attrs: this.radiusAttrItems})
        }
      })
    },
    shown () {
      if (this.isEdit || this.isTariffPlan) {
        for (let el of this.editItem.hotspot_service_data.allowed_net) {
          el.maskDec = this.arrMask.get(el.mask)
          el.num = ++this.num
        }
        this.radiusAttrItems = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/RADIUS_ATTR_SERVICES']))
        for (let el of this.radiusAttrItems) {
          el.value = el.attr_value
          if (el.tag && (el.vendor === 0)) {
            el.value = ':' + el.tag + ':' + el.attr_value
          }
          switch (el.attr_type) {
            case 1:
              el.attrType = this.$i18n.t('Number')
              break
            case 2:
              el.attrType = this.$i18n.t('String')
              break
            case 3:
              el.attrType = 'IP'
              break
            case 4:
              el.attrType = this.$i18n.t('Binary')
              break
          }
        }
      } else {
        this.radiusAttrItems = []
      }
    },
    swohAddTimeRange () {
      this.newTimeRange = JSON.parse(JSON.stringify(this.emptyTimeRange))
      this.isEditTimeRange = false
      this.$refs.modalTimeRange.show()
    },
    ClickOnEditTimeRangeButton (row) {
      this.isEditTimeRange = true
      this.newTimeRange = JSON.parse(JSON.stringify(row.item))
      this.selectTimeRange = this.newTimeRange.timerange_id
      this.$refs.modalTimeRange.show()
    },
    hideModalTimeRange () {
      this.$refs.modalTimeRange.hide()
    },
    saveTimeRange () {
      if (!this.newTimeRange.cost) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid sum format'), 'Error')
        return
      }
      this.newTimeRange.cost = Number(this.newTimeRange.cost)
      if (!this.isEditTimeRange) {
        for (let el of this.editItem.hotspot_service_data.costs) {
          if (el.timerange_id === this.selectTimeRange) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more time range for same id'), 'Error')
            return
          }
        }
        this.newTimeRange.timerange_id = this.selectTimeRange
        for (let el of this.$store.getters['Tariffing/TIME_RANGE']) {
          if (el.tr_id === this.selectTimeRange) {
            this.newTimeRange.time_range_name = el.name
          }
        }
        this.editItem.hotspot_service_data.costs.push(this.newTimeRange)
      } else {
        for (let el of this.editItem.hotspot_service_data.costs) {
          if (this.selectTimeRange === el.timerange_id) {
            el.cost = this.newTimeRange.cost
          }
        }
      }
      this.hideModalTimeRange()
    },
    deleteTimeRange (row) {
      this.editItem.hotspot_service_data.costs = this.editItem.hotspot_service_data.costs.filter((value) => {
        return value !== row.item
      })
    },
    swohAddRadiusAttr () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrButton (row) {
      this.rowRadiusAttr = row.item
      this.isEditRadiusAttr = true
      this.$refs.modalRadiusAttr.show()
    },
    hideAddRadiusAttr () {
      this.$refs.modalRadiusAttr.hide()
    },
    deleteRadiusAttr (row) {
      this.radiusAttrItems = this.radiusAttrItems.filter((value) => {
        return value !== row.item
      })
    },
    swohAddNetwork () {
      this.newNetwork = JSON.parse(JSON.stringify(this.emptyNetwork))
      this.isEditNetwork = false
      this.$refs.modalNetwork.show()
    },
    ClickOnEditNetworkButton (row) {
      this.newNetwork = JSON.parse(JSON.stringify(row.item))
      this.isEditNetwork = true
      this.$refs.modalNetwork.show()
    },
    deleteNetwork (row) {
      this.editItem.hotspot_service_data.allowed_net = this.editItem.hotspot_service_data.allowed_net.filter((value) => {
        return value !== row.item
      })
    },
    saveNetwork () {
      if (!this.newNetwork.network || !this.newNetwork.mask) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field ip or mask'), 'Error')
        return
      }
      if (!this.validationIP()) return
      if (!this.validationMask()) return
      this.newNetwork.maskDec = this.arrMask.get(this.newNetwork.mask)
      if (this.isEditNetwork) {
        for (let el of this.editItem.hotspot_service_data.allowed_net) {
          if (el.num === this.newNetwork.num) {
            el.mask = this.newNetwork.mask
            el.network = this.newNetwork.network
          }
        }
      } else {
        this.newNetwork.num = ++this.num
        this.editItem.hotspot_service_data.allowed_net.push((this.newNetwork))
      }
      this.hideAddNetwork()
    },
    hideAddNetwork () {
      this.$refs.modalNetwork.hide()
    },
    validationIP () {
      let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
      if (this.newNetwork.network.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    },
    validationMask () {
      if (this.arrMask.has(this.newNetwork.mask)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect mask format'), 'Error')
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formHotspotService.vue